import './contact.css'
import React , {useRef} from 'react'
// components 
import {AiOutlineMessage} from 'react-icons/ai'
import {BsInstagram} from 'react-icons/bs'
import emailjs from 'emailjs-com';

const Contact = () => {

  const info = {
    email : 'x0abhie@gmail.com',
    instaId : '__labhishek',
  }

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_3p11gk4', 'template_qdcy8nc', form.current, 'GJhR709RG424esf7l')
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });

    e.target.reset()
  };

  return (
    <section id='contact'>
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>

      <div className="container contact__container">
        <div className="contact__options">

          <article className="contact__option">
            <AiOutlineMessage className='contact__option-icon' />
            <h4>Email</h4>
            <h5>{info.email}</h5>
            <a href={`mailto:${info.email}`} target={`_blank`}>Send a message</a>
          </article>
          
          <article className="contact__option">
            <BsInstagram className='contact__option-icon' />
            <h4>Instagram</h4>
            <h5>{info.instaId}</h5>
            <a href={`https://www.instagram.com/__labhishek/`} target={`_blank`}>Send a message</a>
          </article>

        </div>
        {/*  */}
        <form ref={form} onSubmit={sendEmail}>
          <input type="text" name='name' placeholder='Your Full Name' required/>
          <input type="email" name='email' placeholder='Your Email Id' required/>
          <textarea name="message" rows={'7'} placeholder={`Your Message`} required></textarea>
          <button type='submit' className='btn btn-primary'>Send Message</button>
        </form>
      </div>
    </section>
  )
}

export default Contact